<script>
import { Bar } from 'vue-chartjs'
import Lib from '@/lib'
import _ from 'lodash'
import Percentage from 'percentage'
import Filesize from 'filesize'
import Util from 'util'

export default {
  extends: Bar,
  props: {
    summary: Object,
  },
  mounted() {
    const types = Object.keys(this.summary.images.orig.breakdown);
    const datasets = types.map(t => {
      const data = Object.values(this.summary.images).map(obj => obj.breakdown[t] || 0);
      const orig = this.summary.images.orig.breakdown[t];
      const rate = Percentage((_.min(data) - orig) / orig, 2);
      const name = Lib.preset().i18n.formats[t] || t;
      
      return {
        label: `${name} ${rate}`,
        backgroundColor: Lib.preset().colors.formats[t] || '#ffffff',
        data,
      };
    });

    const labels = Object.keys(this.summary.images).map(k => {
      const name = Lib.preset().i18n.simulations[k];
    });

    this.renderChart(
      {
        labels: Object.keys(this.summary.images).map(k => Lib.preset().i18n.simulations[k]),
        datasets,
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        showAllTooltips: true,
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const values = data.datasets[tooltipItem.datasetIndex].data;
              const display = values.map(v => Filesize(v)).join(' → ')
              const last = values.length - 1
              const reduced = values[last] - values[0]
              const rate = reduced / values[0]

              return `${display} (${Percentage(rate, 1)})`
            },
            title: (tooltipItem, data) => {
              const label = data.datasets[tooltipItem[0].datasetIndex].label
              const [format] = label.split(/\s+/)
              return format
            },
          },
        },
        scales: {
          xAxes: [ { stacked: true } ],
          yAxes: [
            {
              ticks: {
                callback: (value, index, values) => {
                  return Filesize(value)
                },
              },
              stacked: true,
            }
          ],
        }
      }
    );
  }
}
</script>
